<template>
  <div class="card">
    <p class="time">{{ formatSecToString(time) }}</p>
    <a-button type="primary" class="submit" @click="$emit('submit', time)">提交</a-button>
  </div>
</template>
<script>
// import dayjs from 'dayjs'
export default {
  name: '',
  data() {
    return {
      // deadline: Date.now() + 1000 * 60 * 60 * 24 * 2 + 1000 * 30
      time: 0,
      // time: 3599399,
      // endTime: 10 * 60,
      endTime: 1000 * 60 * 60
    }
  },
  created() {
    this.timer = setInterval(() => {
      // this.time++
      if (++this.time >= this.endTime - 1) {
        this.$emit('submit', this.time)
        clearInterval(this.timer)
      }
    }, 1000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    formatSecToString(second) {
      const res = []
      res.push(String(Math.floor(second / 3600)).padStart(2, 0)) // add H
      second %= 3600
      res.push(String(Math.floor(second / 60)).padStart(2, 0)) // add M
      second %= 60
      res.push(String(Math.floor(second % 60)).padStart(2, 0)) // add S
      return res.join(':')
    }
  }
}
</script>
<style lang="less" scoped>
.card {
  padding: 0 16px 16px;
  background: #ffffff;
  border-radius: 15px;
  margin-bottom: 16px;
  overflow: hidden;
}
.time {
  margin-top: 16px;
  font-size: 21px;
  font-weight: bold;
  text-align: center;
}
.submit {
  width: 100%;
  height: 45px;
  line-height: 45px;
  margin-top: 16px;
  background-color: #1564ff;
  font-size: 16px;
  border-radius: 23px;
}
</style>
